import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "publications.title") separator=" | "}}

  {{! Page Header }}
  <section class="page-header" aria-labelledby="publications-title">
    <div class="container">
      <div class="section-header">
        <h1 id="publications-title" class="section-header__title">{{t
            "publications.title"
          }}</h1>
        <p class="section-header__description">
          {{t "publications.subtitle"}}
        </p>
      </div>
    </div>
  </section>

  {{! Publications List }}
  <section class="section" aria-labelledby="papers-title">
    <div class="container">
      <h2 id="papers-title" class="sr-only">{{t
          "publications.papers_title"
        }}</h2>

      <div class="publications-list" role="list">
        {{! Journal Paper - JBI 2015 }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="ScholarlyArticle"
        >
          <h3 class="publication__title" property="headline">
            Semantic processing of EHR data for clinical research
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">Sun, H.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Depraetere, K.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Roo, J.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Mels, G.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Twagirumukiza, M.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Colaert, D.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="isPartOf" typeof="Periodical">
              <span property="name">Journal of Biomedical Informatics</span>
            </span>, 58, 247–259
            <span class="publication__year" property="datePublished">2015</span>
          </p>
          <a
            href="https://doi.org/10.1016/j.jbi.2015.10.009"
            target="_blank"
            rel="noopener noreferrer"
            class="publication__link"
            property="url"
            aria-label="View publication: Semantic processing of EHR data for clinical research (opens in new window)"
          >
            {{t "publications.view_publication"}}
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              ></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </article>

        {{! Patent 2015 }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="CreativeWork"
        >
          <h3 class="publication__title" property="headline">
            Method of using a semantic web data source in a target application
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Depraetere, K.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Colaert, D.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="additionalType">Patent/Method</span>
            <span class="publication__year" property="datePublished">2015</span>
          </p>
        </article>

        {{! SWAT4LS 2013 - SKOS Mapping Quality }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="ScholarlyArticle"
        >
          <h3 class="publication__title" property="headline">
            Assessing and Improving SKOS Mapping Quality
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">Sun, H.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Roo, J.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Mels, G.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Depraetere, K.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Twagirumukiza, M.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Colaert, D.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="isPartOf" typeof="Event">
              <span property="name">SWAT4LS (Semantic Web Applications and Tools
                for Life Sciences)</span>
            </span>
            <span class="publication__year" property="datePublished">2013</span>
          </p>
        </article>

        {{! arXiv 2013 - Validation Rules }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="ScholarlyArticle"
        >
          <h3 class="publication__title" property="headline">
            Validation rules for assessing and improving SKOS mapping quality
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">Sun, H.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Roo, J.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Twagirumukiza, M.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Mels, G.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Depraetere, K.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Colaert, D.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="isPartOf" typeof="Periodical">
              <span property="name">arXiv preprint arXiv:1310.4156</span>
            </span>
            <span class="publication__year" property="datePublished">2013</span>
          </p>
          <a
            href="https://arxiv.org/abs/1310.4156"
            target="_blank"
            rel="noopener noreferrer"
            class="publication__link"
            property="url"
            aria-label="View publication: Validation rules for assessing and improving SKOS mapping quality (opens in new window)"
          >
            {{t "publications.view_on_arxiv"}}
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              ></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </article>

        {{! SWAT4LS 2012 - EHR4CR }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="ScholarlyArticle"
        >
          <h3 class="publication__title" property="headline">
            EHR4CR: A Semantic Web Based Interoperability Approach for Reusing
            Electronic Healthcare Records in Protocol Feasibility Studies
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">Hussain, S.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Ouagne, D.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Sadou, E.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Dart, T.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Jaulent, M.C.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Colaert, D.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Daniel, C.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="isPartOf" typeof="Event">
              <span property="name">SWAT4LS (Semantic Web Applications and Tools
                for Life Sciences)</span>
            </span>
            <span class="publication__year" property="datePublished">2012</span>
          </p>
        </article>

        {{! arXiv 2012 - Semantic Integration }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="ScholarlyArticle"
        >
          <h3 class="publication__title" property="headline">
            Semantic integration and analysis of clinical data
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">Sun, H.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Depraetere, K.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Roo, J.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Mels, G.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Colaert, D.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="isPartOf" typeof="Periodical">
              <span property="name">arXiv preprint arXiv:1210.4405</span>
            </span>
            <span class="publication__year" property="datePublished">2012</span>
          </p>
          <a
            href="https://arxiv.org/abs/1210.4405"
            target="_blank"
            rel="noopener noreferrer"
            class="publication__link"
            property="url"
            aria-label="View publication: Semantic integration and analysis of clinical data (opens in new window)"
          >
            {{t "publications.view_on_arxiv"}}
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              ></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </article>

        {{! BMC Proceedings 2011 }}
        <article
          class="card publication"
          role="listitem"
          vocab="https://schema.org/"
          typeof="ScholarlyArticle"
        >
          <h3 class="publication__title" property="headline">
            A cross-site antimicrobial resistance surveillance system using
            semantic web technologies
          </h3>
          <p class="publication__authors">
            <span property="author" typeof="Person">
              <span property="name">Teodoro, D.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Pasche, E.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Vishnyakova, D.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">De Vloed, B.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Depraetere, K.</span>
            </span>,
            <span property="author" typeof="Person">
              <span property="name">Ruch, P.</span>
            </span>, &amp;
            <span property="author" typeof="Person">
              <span property="name">Lovis, C.</span>
            </span>
          </p>
          <p class="publication__venue">
            <span property="isPartOf" typeof="Periodical">
              <span property="name">BMC Proceedings</span>
            </span>, pp. 1–1
            <span class="publication__year" property="datePublished">2011</span>
          </p>
        </article>
      </div>
    </div>
  </section>

  {{! Research Focus }}
  <section class="section section--alt" aria-labelledby="research-focus-title">
    <div class="container">
      <h2 id="research-focus-title">{{t
          "publications.research_focus.title"
        }}</h2>
      <div class="services-grid">
        <div class="card card--bordered">
          <h3 class="card__title">{{t
              "publications.research_focus.semantic.title"
            }}</h3>
          <p class="card__description">
            {{t "publications.research_focus.semantic.description"}}
          </p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">{{t
              "publications.research_focus.skos.title"
            }}</h3>
          <p class="card__description">
            {{t "publications.research_focus.skos.description"}}
          </p>
        </div>
        <div class="card card--bordered">
          <h3 class="card__title">{{t
              "publications.research_focus.clinical.title"
            }}</h3>
          <p class="card__description">
            {{t "publications.research_focus.clinical.description"}}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
